import React from 'react';

import DurationArrowIconSrc from '../../../assets/images/duration-arrow-icon.png';

export const DurationArrowIcon = () => {
    return <img width={'50px'} height={'50px'} src={DurationArrowIconSrc}/>;
};
